"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnv = void 0;
const getEnv = baseUrl => {
  try {
    const url = new URL(baseUrl);
    const hostname = url === null || url === void 0 ? void 0 : url.hostname;
    const parts = hostname === null || hostname === void 0 ? void 0 : hostname.split('.');
    if (parts) {
      const firstPart = parts[0];
      const lastPart = parts[parts.length - 1];
      if (lastPart === 'cn') {
        switch (firstPart) {
          case 'wwwdeve':
            return 'deve-china';
          case 'wwwtest':
            return 'qa-china';
          case 'solutions':
          case 'www':
          case 'identity':
            return 'prod-china';
          default:
            break;
        }
      } else {
        switch (firstPart) {
          case 'localhost':
            return 'deve';
          case 'deve':
          case 'wwwdeve':
          case 'identity-dev':
            return 'deve';
          case 'identity-dev-cn':
            return 'deve-china';
          case 'qa':
          case 'wwwtest':
          case 'identity-qa':
            return 'qa';
          case 'identity-qa-cn':
            return 'qa-china';
          case 'prelive':
          case 'wwwpre':
            return 'prelive';
          case 'solutions':
          case 'www':
          case 'identity':
            return 'prod';
          default:
            break;
        }
      }
    }
    return null;
  } catch (_a) {
    return null;
  }
};
exports.getEnv = getEnv;
//# sourceMappingURL=envDetector.js.map